var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wf-component wf-tab-buttons"},[_c('div',{directives:[{name:"touch",rawName:"v-touch:tap",value:(_vm.switchTab('search')),expression:"switchTab('search')",arg:"tap"}],staticClass:"wf-item tab-search",class:{active: _vm.currentTab == 'search'},attrs:{"data-translation-element":"search"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }